<template>
  <div class="student-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">学员档案管理</span>
      </div>
    </div>

    <!-- 标签页 -->
    <el-tabs v-model="activeTab" class="main-tabs" @tab-change="handleTabChange">
      <!-- 学员列表标签页 -->
      <el-tab-pane label="学员列表" name="student">
        <div class="search-bar" style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <el-input placeholder="姓名/电话/身份证" v-model="searchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="handleSearch">
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select v-model="searchForm.studentStatus" placeholder="学员状态" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
              <el-option label="潜在学员" value="POTENTIAL" />
              <el-option label="在学学员" value="ACTIVE" />
              <el-option label="已毕业" value="COMPLETED" />
              <el-option label="已退学" value="DROPPED" />
            </el-select>
            <el-select v-model="searchForm.paymentStatus" placeholder="缴费状态" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
              <el-option label="未缴费" value="UNPAID" />
              <el-option label="部分缴费" value="PARTIAL" />
              <el-option label="已缴清" value="PAID" />
            </el-select>
            <el-select v-model="searchForm.examType" placeholder="报考车型" clearable style="width: 100px; margin-left: 10px;" @change="handleSearch">
              <el-option label="C1" value="C1" />
              <el-option label="C2" value="C2" />
              <el-option label="A1" value="A1" />
            </el-select>
            <el-select v-model="searchForm.coachUserId" placeholder="分配教练" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
              <el-option v-for="coach in coachList" :key="coach.id" :label="coach.name" :value="coach.id" />
            </el-select>
            <el-select v-model="searchForm.driverUserId" placeholder="分配司机" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
              <el-option v-for="driver in driverList" :key="driver.id" :label="driver.name" :value="driver.id" />
            </el-select>
            <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">
              <i class="el-icon-search"></i> 查询
            </el-button>
            <el-button @click="handleReset" style="margin-left: 10px;">
              <i class="el-icon-refresh"></i> 重置
            </el-button>
          </div>
          <el-button type="primary" @click="handleCreate">
            <i class="el-icon-plus"></i> 新建学员
          </el-button>
        </div>

        <!-- 统计卡片 -->
        <div class="stats-cards">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon potential"><i class="el-icon-user"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.potential }}</div>
                  <div class="stat-label">潜在学员</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon active"><i class="el-icon-reading"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.active }}</div>
                  <div class="stat-label">在学学员</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon completed"><i class="el-icon-circle-check"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.completed }}</div>
                  <div class="stat-label">已毕业</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon unpaid"><i class="el-icon-warning"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.unpaid }}</div>
                  <div class="stat-label">待缴尾款</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-table
            v-loading="loading"
            :data="tableData"
            stripe
            border
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <el-table-column prop="studentName" label="姓名" width="100" fixed />
            <el-table-column prop="contactPhone" label="联系电话" width="120" />
            <el-table-column prop="examType" label="车型" width="70">
              <template slot-scope="scope">
                <el-tag size="small">{{ scope.row.examType || '-' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="currentSubject" label="当前科目" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.currentSubject">{{ scope.row.currentSubject }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="studentStatus" label="学员状态" width="100">
              <template slot-scope="scope">
                <el-tag size="small" :type="getStatusTagType(scope.row.studentStatus)">
                  {{ getStatusName(scope.row.studentStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="paymentStatus" label="缴费状态" width="100">
              <template slot-scope="scope">
                <el-tag size="small" :type="getPaymentTagType(scope.row.paymentStatus)">
                  {{ getPaymentName(scope.row.paymentStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="费用信息" width="180">
              <template slot-scope="scope">
                <span>已缴: ¥{{ scope.row.paidAmount || 0 }}</span>
                <br>
                <span class="unpaid">欠款: ¥{{ scope.row.unpaidAmount || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="salesUserName" label="业务员" width="100" />
            <el-table-column prop="coachUserName" label="教练" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.coachUserName">{{ scope.row.coachUserName }}</span>
                <span v-else class="no-assign">待分配</span>
              </template>
            </el-table-column>
            <el-table-column prop="driverUserName" label="司机" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.driverUserName">{{ scope.row.driverUserName }}</span>
                <span v-else class="no-assign">待分配</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" />
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click="handleAssign(scope.row)">分配</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <span class="total-text">共 {{ total }} 条记录</span>
            <el-pagination
              background
              layout="sizes, prev, pager, next"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
            />
          </div>
      </el-tab-pane>

      <!-- 缴费管理标签页 -->
      <el-tab-pane label="缴费管理" name="payment">
        <div class="search-bar" style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <el-input placeholder="关键词" v-model="paymentSearchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="loadPaymentList">
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select v-model="paymentSearchForm.auditStatus" placeholder="审核状态" clearable style="width: 130px; margin-left: 10px;" @change="loadPaymentList">
              <el-option label="待审核" value="PENDING" />
              <el-option label="已通过" value="APPROVED" />
              <el-option label="已拒绝" value="REJECTED" />
              <el-option label="已锁定" value="LOCKED" />
            </el-select>
            <el-select v-model="paymentSearchForm.paymentStage" placeholder="缴费阶段" clearable style="width: 130px; margin-left: 10px;" @change="loadPaymentList">
              <el-option label="定金" value="DEPOSIT" />
              <el-option label="尾款" value="FINAL" />
              <el-option label="全款" value="FULL" />
            </el-select>
            <el-button type="primary" @click="loadPaymentList" style="margin-left: 10px;">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </div>
          <el-button type="primary" @click="handleAddPayment">
            <i class="el-icon-plus"></i> 新建缴费
          </el-button>
        </div>

        <!-- 缴费统计卡片 -->
        <div class="stats-cards">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon pending"><i class="el-icon-time"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ paymentStats.pending }}</div>
                  <div class="stat-label">待审核</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon approved"><i class="el-icon-check"></i></div>
                <div class="stat-info">
                  <div class="stat-value">¥{{ paymentStats.approvedAmount }}</div>
                  <div class="stat-label">已通过金额</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon total"><i class="el-icon-money"></i></div>
                <div class="stat-info">
                  <div class="stat-value">¥{{ paymentStats.totalAmount }}</div>
                  <div class="stat-label">缴费总额</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon unpaid"><i class="el-icon-warning"></i></div>
                <div class="stat-info">
                  <div class="stat-value">¥{{ paymentStats.unpaidAmount }}</div>
                  <div class="stat-label">待收款</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-table
            v-loading="paymentLoading"
            :data="paymentData"
            stripe
            border
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <el-table-column prop="studentName" label="学员姓名" width="100" />
            <el-table-column prop="paymentTypeName" label="缴费类型" width="100">
              <template slot-scope="scope">
                <el-tag size="small">{{ scope.row.paymentTypeName }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="paymentAmount" label="缴费金额" width="100">
              <template slot-scope="scope">
                <span class="money">¥{{ scope.row.paymentAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="paymentDate" label="缴费日期" width="120" />
            <el-table-column prop="paymentMethodName" label="缴费方式" width="100" />
            <el-table-column prop="salesUserName" label="业务员" width="100" />
            <el-table-column prop="statusName" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag size="small" :type="getPaymentStatusTagType(scope.row.status)">
                  {{ scope.row.statusName }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="financeUserName" label="审核人" width="100" />
            <el-table-column prop="financeApproveTime" label="审核时间" width="160" />
            <el-table-column prop="createTime" label="创建时间" width="160" />
            <el-table-column label="操作" width="380"> fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleViewPayment(scope.row)">查看</el-button>
                <el-button type="text" size="small" v-if="scope.row.status === 'PENDING'" @click="handleEditPayment(scope.row)" style="color: #409eff;">修改</el-button>
                <el-button type="text" size="small" v-if="scope.row.status === 'PENDING'" @click="handleApprovePayment(scope.row, 'APPROVED')" style="color: #67c23a;">通过</el-button>
                <el-button type="text" size="small" v-if="scope.row.status === 'PENDING'" @click="handleRejectPayment(scope.row)" style="color: #f56c6c;">拒绝</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <span class="total-text">共 {{ paymentTotal }} 条记录</span>
            <el-pagination
              background
              layout="sizes, prev, pager, next"
              :current-page="paymentPagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="paymentPagination.pageSize"
              :total="paymentTotal"
              @size-change="handlePaymentSizeChange"
              @current-change="handlePaymentPageChange"
            />
          </div>
      </el-tab-pane>

      <!-- 培训统计标签页 -->
      <el-tab-pane label="培训统计" name="train-stats">
        <div class="search-bar" style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <el-input placeholder="关键词" v-model="trainStatsSearchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="loadTrainStats">
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select v-model="trainStatsSearchForm.trainSubject" placeholder="培训科目" clearable style="width: 100px; margin-left: 10px;" @change="loadTrainStats">
              <el-option label="科一" value="K1" />
              <el-option label="科二" value="K2" />
              <el-option label="科三" value="K3" />
              <el-option label="科四" value="K4" />
            </el-select>
            <el-date-picker
              v-model="trainStatsSearchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 240px; margin-left: 10px;"
              @change="loadTrainStats"
            />
            <el-button type="primary" @click="loadTrainStats" style="margin-left: 10px;">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </div>
        </div>

        <!-- 统计概览 -->
        <div class="stats-cards">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-icon total"><i class="el-icon-user"></i></div>
              <div class="stat-info">
                <div class="stat-value">{{ trainStatsOverview.totalStudents }}</div>
                <div class="stat-label">培训学员</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-icon k2"><i class="el-icon-truck"></i></div>
              <div class="stat-info">
                <div class="stat-value">{{ trainStatsOverview.k2Count }}</div>
                <div class="stat-label">科二培训</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-icon k3"><i class="el-icon-map-location"></i></div>
              <div class="stat-info">
                <div class="stat-value">{{ trainStatsOverview.k3Count }}</div>
                <div class="stat-label">科三培训</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-icon hours"><i class="el-icon-time"></i></div>
              <div class="stat-info">
                <div class="stat-value">{{ trainStatsOverview.totalHours }}</div>
                <div class="stat-label">总培训学时</div>
              </div>
            </div>
          </el-col>
        </el-row>
        </div>

          <el-table
            v-loading="trainStatsLoading"
            :data="trainStatsData"
            stripe
            border
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <el-table-column prop="studentName" label="学员姓名" width="100" />
            <el-table-column prop="coachUserName" label="教练" width="100" />
            <el-table-column prop="trainDate" label="培训日期" width="110" />
            <el-table-column prop="trainSubject" label="培训科目" width="100">
              <template slot-scope="scope">
                <el-tag size="small" :type="getSubjectTagType(scope.row.trainSubject)">
                  {{ getSubjectName(scope.row.trainSubject) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="trainContent" label="培训内容" width="200" show-overflow-tooltip />
            <el-table-column prop="trainHours" label="培训学时" width="80">
              <template slot-scope="scope">
                {{ scope.row.trainHours || 0 }}学时
              </template>
            </el-table-column>
            <el-table-column prop="progressRecord" label="进度记录" width="200" show-overflow-tooltip />
            <el-table-column prop="createTime" label="登记时间" width="160" />
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleEditTrainRecord(scope.row)" style="color: #409eff;">修改</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <span class="total-text">共 {{ trainStatsTotal }} 条记录</span>
            <el-pagination
              background
              layout="sizes, prev, pager, next"
              :current-page="trainStatsPagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="trainStatsPagination.pageSize"
              :total="trainStatsTotal"
            @size-change="handleTrainStatsSizeChange"
            @current-change="handleTrainStatsPageChange"
          />
        </div>
      </el-tab-pane>

      <!-- 考试成绩记录标签页 -->
      <el-tab-pane label="考试成绩记录" name="exam">
        <div class="search-bar" style="display: flex; justify-content: space-between; align-items: center;">
          <div>
            <el-input placeholder="关键词" v-model="examSearchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="loadExamRecords">
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-select v-model="examSearchForm.examResult" placeholder="考试结果" clearable style="width: 100px; margin-left: 10px;" @change="loadExamRecords">
              <el-option label="合格" value="PASS" />
              <el-option label="不合格" value="FAIL" />
            </el-select>
            <el-button type="primary" @click="loadExamRecords" style="margin-left: 10px;">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </div>
        </div>

        <el-table
            v-loading="examLoading"
            :data="examData"
            stripe
            border
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
          >
            <el-table-column prop="studentName" label="学员姓名" width="100" />
            <el-table-column prop="examSubject" label="考试科目" width="100">
              <template slot-scope="scope">
                {{ getSubjectName(scope.row.examSubject) }}
              </template>
            </el-table-column>
            <el-table-column prop="examDate" label="考试日期" width="110" />
            <el-table-column prop="examTimes" label="考试次数" width="80" />
            <el-table-column prop="score" label="分数" width="70">
              <template slot-scope="scope">
                {{ scope.row.score ? scope.row.score + '分' : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="examResult" label="结果" width="80">
              <template slot-scope="scope">
                <el-tag size="small" :type="scope.row.examResult === 'PASS' ? 'success' : 'danger'">
                  {{ scope.row.examResult === 'PASS' ? '合格' : '不合格' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="failReason" label="不合格原因" width="150" show-overflow-tooltip />
            <el-table-column prop="coachUserName" label="登记教练" width="100" />
            <el-table-column prop="createTime" label="登记时间" width="160" />
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleEditExam(scope.row)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper">
            <span class="total-text">共 {{ examTotal }} 条记录</span>
            <el-pagination
              background
              layout="sizes, prev, pager, next"
              :current-page="examPagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="examPagination.pageSize"
              :total="examTotal"
              @size-change="handleExamSizeChange"
              @current-change="handleExamPageChange"
            />
          </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 修改培训记录弹窗 -->
    <el-dialog title="修改培训记录" :visible.sync="editTrainRecordVisible" width="600px" @closed="resetTrainRecordForm">
      <el-form :model="trainRecordForm" :rules="trainRecordRules" ref="trainRecordFormRef" label-width="100px">
        <el-form-item label="学员姓名">
          <span>{{ trainRecordForm.studentName }}</span>
        </el-form-item>
        <el-form-item label="培训科目" prop="trainSubject">
          <el-select v-model="trainRecordForm.trainSubject" placeholder="请选择培训科目" style="width: 100%">
            <el-option label="科一" value="K1" />
            <el-option label="科二" value="K2" />
            <el-option label="科三" value="K3" />
            <el-option label="科四" value="K4" />
          </el-select>
        </el-form-item>
        <el-form-item label="培训日期" prop="trainDate">
          <el-date-picker v-model="trainRecordForm.trainDate" type="date" placeholder="选择培训日期" style="width: 100%" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item label="培训学时" prop="trainHours">
          <el-input-number v-model="trainRecordForm.trainHours" :min="0" :max="100" style="width: 100%" />
        </el-form-item>
        <el-form-item label="培训内容" prop="trainContent">
          <el-input v-model="trainRecordForm.trainContent" type="textarea" :rows="3" placeholder="请输入培训内容" />
        </el-form-item>
        <el-form-item label="进度记录" prop="progressRecord">
          <el-input v-model="trainRecordForm.progressRecord" type="textarea" :rows="2" placeholder="请输入进度记录" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editTrainRecordVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTrainRecord" :loading="trainRecordLoading">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 修改考试成绩记录弹窗 -->
    <el-dialog title="修改考试成绩" :visible.sync="editExamRecordVisible" width="600px" @closed="resetExamRecordForm">
      <el-form :model="examRecordForm" ref="examRecordFormRef" label-width="100px">
        <el-form-item label="学员姓名">
          <span>{{ examRecordForm.studentName }}</span>
        </el-form-item>
        <el-form-item label="考试科目" prop="examSubject">
          <el-select v-model="examRecordForm.examSubject" placeholder="请选择考试科目" style="width: 100%">
            <el-option label="科一" value="K1" />
            <el-option label="科二" value="K2" />
            <el-option label="科三" value="K3" />
            <el-option label="科四" value="K4" />
          </el-select>
        </el-form-item>
        <el-form-item label="考试日期" prop="examDate">
          <el-date-picker v-model="examRecordForm.examDate" type="date" placeholder="选择考试日期" style="width: 100%" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item label="考试次数" prop="examTimes">
          <el-input-number v-model="examRecordForm.examTimes" :min="1" :max="10" style="width: 100%" />
        </el-form-item>
        <el-form-item label="考试结果" prop="examResult">
          <el-radio-group v-model="examRecordForm.examResult">
            <el-radio label="PASS">合格</el-radio>
            <el-radio label="FAIL">不合格</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="考试分数" prop="score">
          <el-input-number v-model="examRecordForm.score" :min="0" :max="100" style="width: 100%" />
        </el-form-item>
        <el-form-item label="不合格原因" prop="failReason" v-if="examRecordForm.examResult === 'FAIL'">
          <el-input v-model="examRecordForm.failReason" type="textarea" :rows="2" placeholder="请输入不合格原因" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="examRecordForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editExamRecordVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitExamRecord" :loading="examRecordLoading">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 新建/编辑学员弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
      <el-form ref="studentForm" :model="studentForm" :rules="studentRules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="学员姓名" prop="studentName">
              <el-input v-model="studentForm.studentName" placeholder="请输入学员姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input v-model="studentForm.contactPhone" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCardNo">
              <el-input v-model="studentForm.idCardNo" placeholder="请输入身份证号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报考车型" prop="examType">
              <el-select v-model="studentForm.examType" placeholder="请选择" style="width: 100%">
                <el-option label="C1" value="C1" />
                <el-option label="C2" value="C2" />
                <el-option label="A1" value="A1" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 身份证照片上传 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证正面">
              <file-upload
                class="id-card-uploader"
                action="/image/upload?thumbSize=50"
                :isPermanent="true"
                :showLoading="true"
                :maxSize="5 * 1024 * 1024"
                :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']"
                @success="(data) => onIdCardFrontSuccess(data)"
              >
                <div v-if="studentForm.idCardFrontUrl" class="id-card-preview">
                  <el-image :src="studentForm.idCardFrontUrl" fit="contain" style="width: 100%; height: 100px;" />
                  <div class="upload-tip">点击更换</div>
                </div>
                <div v-else class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <span>点击上传</span>
                </div>
              </file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证背面">
              <file-upload
                class="id-card-uploader"
                action="/image/upload?thumbSize=50"
                :isPermanent="true"
                :showLoading="true"
                :maxSize="5 * 1024 * 1024"
                :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']"
                @success="(data) => onIdCardBackSuccess(data)"
              >
                <div v-if="studentForm.idCardBackUrl" class="id-card-preview">
                  <el-image :src="studentForm.idCardBackUrl" fit="contain" style="width: 100%; height: 100px;" />
                  <div class="upload-tip">点击更换</div>
                </div>
                <div v-else class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <span>点击上传</span>
                </div>
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="户籍地">
              <el-input v-model="studentForm.hometown" placeholder="请输入户籍地" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现所在地">
              <el-input v-model="studentForm.currentLocation" placeholder="请输入现所在地" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="出发城市">
              <el-input v-model="studentForm.departureCity" placeholder="请输入出发城市" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抵达城市">
              <el-input v-model="studentForm.arrivalCity" placeholder="请输入抵达城市" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="预计抵达">
              <el-date-picker v-model="studentForm.expectedArrivalTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车票信息">
              <el-input v-model="studentForm.trainInfo" placeholder="车次/航班号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收费总价">
              <el-input-number v-model="studentForm.totalFee" :min="0" :precision="2" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前科目">
              <el-select v-model="studentForm.currentSubject" placeholder="请选择" style="width: 100%">
                <el-option label="待分配" value="" />
                <el-option label="科一(理论)" value="K1" />
                <el-option label="科二(场地)" value="K2" />
                <el-option label="科三(道路)" value="K3" />
                <el-option label="科四(安全)" value="K4" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="学员状态">
              <el-select v-model="studentForm.studentStatus" placeholder="请选择" style="width: 100%">
                <el-option label="潜在学员" value="POTENTIAL" />
                <el-option label="在学学员" value="ACTIVE" />
                <el-option label="已毕业" value="COMPLETED" />
                <el-option label="已退学" value="DROPPED" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款阶段">
              <el-select v-model="studentForm.paymentStage" placeholder="请选择" style="width: 100%">
                <el-option label="未付款" value="NONE" />
                <el-option label="定金" value="DEPOSIT" />
                <el-option label="分期" value="INSTALLMENT" />
                <el-option label="全款" value="FULL" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="studentForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 分配教练司机弹窗 -->
    <el-dialog title="分配教练和司机" :visible.sync="assignDialogVisible" width="500px">
      <el-form ref="assignForm" :model="assignForm" label-width="100px">
        <el-form-item label="学员姓名">
          <span>{{ assignForm.studentName }}</span>
        </el-form-item>
        <el-form-item label="分配教练">
          <el-select v-model="assignForm.coachUserId" placeholder="请选择教练" filterable style="width: 100%">
            <el-option v-for="coach in coachList" :key="coach.id" :label="coach.name" :value="coach.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="分配司机">
          <el-select v-model="assignForm.driverUserId" placeholder="请选择司机" filterable style="width: 100%">
            <el-option v-for="driver in driverList" :key="driver.id" :label="driver.name" :value="driver.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAssignSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="学员详情" :visible.sync="viewDialogVisible" width="700px">
        <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="姓名">{{ viewData.studentName }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ viewData.contactPhone }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ viewData.idCardNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="报考车型">{{ viewData.examType || '-' }}</el-descriptions-item>
        <el-descriptions-item label="当前科目">{{ viewData.currentSubject ? getSubjectName(viewData.currentSubject) : '-' }}</el-descriptions-item>
        <el-descriptions-item label="户籍地">{{ viewData.hometown || '-' }}</el-descriptions-item>
        <el-descriptions-item label="现所在地">{{ viewData.currentLocation || '-' }}</el-descriptions-item>
        <el-descriptions-item label="出发城市">{{ viewData.departureCity || '-' }}</el-descriptions-item>
        <el-descriptions-item label="抵达城市">{{ viewData.arrivalCity || '-' }}</el-descriptions-item>
        <el-descriptions-item label="预计抵达">{{ viewData.expectedArrivalTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="车票信息">{{ viewData.trainInfo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收费总价">¥{{ viewData.totalFee || 0 }}</el-descriptions-item>
        <el-descriptions-item label="已缴金额">¥{{ viewData.paidAmount || 0 }}</el-descriptions-item>
        <el-descriptions-item label="欠款金额">
          <span class="unpaid">¥{{ viewData.unpaidAmount || 0 }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="付款阶段">{{ getPaymentStageName(viewData.paymentStage) }}</el-descriptions-item>
        <el-descriptions-item label="学员状态">
          <el-tag :type="getStatusTagType(viewData.studentStatus)">
            {{ getStatusName(viewData.studentStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="业务员">{{ viewData.salesUserName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="分配教练">{{ viewData.coachUserName || '待分配' }}</el-descriptions-item>
        <el-descriptions-item label="分配司机">{{ viewData.driverUserName || '待分配' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ viewData.createTime }}</el-descriptions-item>
        <el-descriptions-item label="身份证照片" :span="2">
          <div class="id-card-images" v-if="viewData.idCardFrontUrl || viewData.idCardBackUrl">
            <div class="id-card-item" v-if="viewData.idCardFrontUrl">
              <span class="id-card-label">正面:</span>
              <el-image :src="viewData.idCardFrontUrl" style="width: 120px; height: 80px;" fit="contain" :preview-src-list="[viewData.idCardFrontUrl]" />
            </div>
            <div class="id-card-item" v-if="viewData.idCardBackUrl">
              <span class="id-card-label">背面:</span>
              <el-image :src="viewData.idCardBackUrl" style="width: 120px; height: 80px;" fit="contain" :preview-src-list="[viewData.idCardBackUrl]" />
            </div>
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 缴费详情弹窗 -->
    <el-dialog title="缴费详情" :visible.sync="paymentDetailVisible" width="600px">
      <el-descriptions :column="2" border v-if="paymentDetail">
        <el-descriptions-item label="学员姓名">{{ paymentDetail.studentName }}</el-descriptions-item>
        <el-descriptions-item label="缴费类型">{{ paymentDetail.paymentTypeName }}</el-descriptions-item>
        <el-descriptions-item label="缴费金额">
          <span class="money">¥{{ paymentDetail.paymentAmount }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="缴费日期">{{ paymentDetail.paymentDate }}</el-descriptions-item>
        <el-descriptions-item label="缴费方式">{{ paymentDetail.paymentMethodName }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag :type="getPaymentStatusTagType(paymentDetail.status)">{{ paymentDetail.statusName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="业务员">{{ paymentDetail.salesUserName }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{ paymentDetail.financeUserName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ paymentDetail.financeApproveTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核备注">{{ paymentDetail.financeApproveRemark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="凭证" :span="2">
          <el-image v-if="paymentDetail.voucherUrl" :src="paymentDetail.voucherUrl" style="width: 100px; height: 100px;" :preview-src-list="[paymentDetail.voucherUrl]" />
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ paymentDetail.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ paymentDetail.createTime }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="paymentDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新建缴费弹窗 -->
    <el-dialog title="新建缴费" :visible.sync="addPaymentVisible" width="600px" @closed="resetPaymentForm">
      <el-form :model="paymentForm" :rules="paymentRules" ref="paymentFormRef" label-width="100px">
        <el-form-item label="选择学员" prop="studentId">
          <el-select
            v-model="paymentForm.studentId"
            filterable
            remote
            placeholder="搜索学员姓名或电话"
            :remote-method="searchStudents"
            :loading="studentSearchLoading"
            style="width: 100%"
            @change="onStudentChange"
          >
            <el-option
              v-for="item in studentOptions"
              :key="item.id"
              :label="item.studentName + ' - ' + item.contactPhone"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学员信息" v-if="paymentForm.studentId">
          <el-descriptions :column="2" size="small" border>
            <el-descriptions-item label="报考车型">{{ selectedStudentInfo.examType || '-' }}</el-descriptions-item>
            <el-descriptions-item label="总费用">¥{{ selectedStudentInfo.totalFee || 0 }}</el-descriptions-item>
            <el-descriptions-item label="已缴金额">¥{{ selectedStudentInfo.paidAmount || 0 }}</el-descriptions-item>
            <el-descriptions-item label="欠款金额"><span style="color: #f56c6c;">¥{{ selectedStudentInfo.unpaidAmount || 0 }}</span></el-descriptions-item>
          </el-descriptions>
        </el-form-item>
        <el-form-item label="缴费阶段" prop="paymentStage">
          <el-select v-model="paymentForm.paymentStage" placeholder="请选择缴费阶段" style="width: 100%">
            <el-option label="定金" value="DEPOSIT" />
            <el-option label="首付" value="FIRST" />
            <el-option label="中期" value="MIDDLE" />
            <el-option label="尾款" value="FINAL" />
            <el-option label="全款" value="FULL" />
          </el-select>
        </el-form-item>
        <el-form-item label="缴费金额" prop="amount">
          <el-input-number v-model="paymentForm.amount" :min="0" :precision="2" :controls="false" style="width: 100%" placeholder="请输入缴费金额" />
        </el-form-item>
        <el-form-item label="缴费方式" prop="paymentMethod">
          <el-select v-model="paymentForm.paymentMethod" placeholder="请选择缴费方式" style="width: 100%">
            <el-option label="现金" value="CASH" />
            <el-option label="微信" value="WECHAT" />
            <el-option label="支付宝" value="ALIPAY" />
            <el-option label="银行转账" value="BANK_TRANSFER" />
            <el-option label="其他" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item label="缴费日期" prop="paymentDate">
          <el-date-picker v-model="paymentForm.paymentDate" type="date" placeholder="选择缴费日期" style="width: 100%" value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-form-item label="上传凭证" prop="voucherUrl">
          <file-upload
            class="voucher-uploader"
            action="/image/upload?thumbSize=50"
            :isPermanent="true"
            :showLoading="true"
            :maxSize="5 * 1024 * 1024"
            :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']"
            @success="onVoucherSuccess"
          >
            <div v-if="paymentForm.voucherUrl" class="voucher-preview-box">
              <el-image :src="paymentForm.voucherUrl" fit="contain" style="width: 100%; height: 100px;" />
              <div class="upload-tip">点击更换</div>
            </div>
            <div v-else class="upload-placeholder">
              <i class="el-icon-plus"></i>
              <span>点击上传凭证</span>
            </div>
          </file-upload>
          <div class="form-tip">支持jpg、png等图片格式</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="paymentForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addPaymentVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPayment" :loading="paymentSubmitting">提交</el-button>
      </div>
    </el-dialog>

    <!-- 修改缴费弹窗 -->
    <el-dialog title="修改缴费" :visible.sync="editPaymentVisible" width="600px" @closed="resetPaymentForm">
      <el-form :model="paymentForm" :rules="paymentRules" ref="paymentFormRef" label-width="100px">
        <el-form-item label="缴费阶段" prop="paymentStage">
          <el-select v-model="paymentForm.paymentStage" placeholder="请选择缴费阶段" style="width: 100%">
            <el-option label="定金" value="DEPOSIT" />
            <el-option label="首付" value="FIRST" />
            <el-option label="中期" value="MIDDLE" />
            <el-option label="尾款" value="FINAL" />
            <el-option label="全款" value="FULL" />
          </el-select>
        </el-form-item>
        <el-form-item label="缴费金额" prop="amount">
          <el-input-number v-model="paymentForm.amount" :min="0" :precision="2" :controls="false" style="width: 100%" placeholder="请输入缴费金额" />
        </el-form-item>
        <el-form-item label="缴费方式" prop="paymentMethod">
          <el-select v-model="paymentForm.paymentMethod" placeholder="请选择缴费方式" style="width: 100%">
            <el-option label="现金" value="CASH" />
            <el-option label="微信" value="WECHAT" />
            <el-option label="支付宝" value="ALIPAY" />
            <el-option label="银行转账" value="BANK_TRANSFER" />
            <el-option label="其他" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item label="上传凭证" prop="voucherUrl">
          <file-upload
            class="voucher-uploader"
            action="/image/upload?thumbSize=50"
            :isPermanent="true"
            :hasThumb="true"
            :maxSize="10"
            :limit="1"
            v-model="paymentForm.voucherUrl"
          >
            <div v-if="!paymentForm.voucherUrl" class="voucher-placeholder">
              <i class="el-icon-plus"></i>
              <div class="upload-text">点击上传凭证</div>
            </div>
          </file-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="paymentForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editPaymentVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditPayment" :loading="paymentSubmitting">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as studentApi from '@/api/studentApi.js'
import * as coachApi from '@/api/coachApi.js'
import FileUpload from '@/components/common/FileUpload.vue'

export default {
  name: 'StudentManage',
  components: {
    FileUpload
  },
  data() {
    return {
      activeTab: 'student',
      searchForm: {
        keyword: '',
        studentStatus: '',
        paymentStatus: '',
        examType: '',
        coachUserId: '',
        driverUserId: ''
      },
      statsOverview: {
        potential: 0,
        active: 0,
        completed: 0,
        unpaid: 0
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0,

      dialogVisible: false,
      dialogTitle: '新建学员',
      studentForm: {
        studentName: '',
        contactPhone: '',
        idCardNo: '',
        idCardFrontUrl: '',
        idCardBackUrl: '',
        examType: '',
        hometown: '',
        currentLocation: '',
        departureCity: '',
        arrivalCity: '',
        expectedArrivalTime: '',
        trainInfo: '',
        currentSubject: '',
        totalFee: 0,
        paymentStage: 'NONE',
        studentStatus: 'POTENTIAL',
        remark: ''
      },
      studentRules: {
        studentName: [{ required: true, message: '请输入学员姓名', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      submitLoading: false,
      editId: null,

      assignDialogVisible: false,
      assignForm: {
        studentId: null,
        studentName: '',
        coachUserId: null,
        driverUserId: null
      },
      coachList: [],
      driverList: [],

      viewDialogVisible: false,
      viewData: null,

      // 缴费管理相关
      paymentSearchForm: {
        keyword: '',
        auditStatus: '',
        paymentStage: ''
      },
      paymentData: [],
      paymentLoading: false,
      paymentPagination: {
        page: 1,
        pageSize: 20
      },
      paymentTotal: 0,
      paymentStats: {
        pending: 0,
        approvedAmount: 0,
        totalAmount: 0,
        unpaidAmount: 0
      },
      paymentDetailVisible: false,
      paymentDetail: null,

      // 新建缴费相关
      addPaymentVisible: false,
      editPaymentVisible: false,
      paymentForm: {
        studentId: null,
        paymentStage: '',
        amount: 0,
        paymentMethod: '',
        paymentDate: '',
        voucherUrl: '',
        remark: ''
      },
      editingPaymentId: null,
      paymentRules: {
        studentId: [{ required: true, message: '请选择学员', trigger: 'change' }],
        paymentStage: [{ required: true, message: '请选择缴费阶段', trigger: 'change' }],
        amount: [{ required: true, message: '请输入缴费金额', trigger: 'blur' }],
        paymentMethod: [{ required: true, message: '请选择缴费方式', trigger: 'change' }]
      },
      editTrainRecordVisible: false,
      trainRecordLoading: false,
      trainRecordForm: {
        id: '',
        studentName: '',
        trainSubject: '',
        trainDate: '',
        trainHours: 0,
        trainContent: '',
        progressRecord: ''
      },
      trainRecordRules: {
        trainSubject: [{ required: true, message: '请选择培训科目', trigger: 'change' }],
        trainDate: [{ required: true, message: '请选择培训日期', trigger: 'change' }],
        trainHours: [{ required: true, message: '请输入培训学时', trigger: 'change' }]
      },
      // 考试成绩修改相关
      editExamRecordVisible: false,
      examRecordLoading: false,
      examRecordForm: {
        id: '',
        studentName: '',
        examSubject: '',
        examDate: '',
        examTimes: 1,
        examResult: 'PASS',
        score: 0,
        failReason: '',
        remark: ''
      },
      studentOptions: [],
      studentSearchLoading: false,
      selectedStudentInfo: {},
      paymentSubmitting: false,

      // 培训统计相关
      trainStatsSearchForm: {
        keyword: '',
        trainSubject: '',
        dateRange: []
      },
      trainStatsData: [],
      trainStatsLoading: false,
      trainStatsPagination: {
        page: 1,
        pageSize: 20
      },
      trainStatsTotal: 0,
      trainStatsOverview: {
        totalStudents: 0,
        k2Count: 0,
        k3Count: 0,
        totalHours: 0
      },

      // 考试成绩相关
      examSearchForm: {
        keyword: '',
        examResult: ''
      },
      examData: [],
      examLoading: false,
      examPagination: {
        page: 1,
        pageSize: 20
      },
      examTotal: 0
    }
  },
  created() {
    // 从路由参数读取初始标签页
    const tab = this.$route.query.tab
    if (tab && ['student', 'payment', 'train-stats', 'exam'].includes(tab)) {
      this.activeTab = tab
    }
    this.loadCoachList()
    this.loadDriverList()
    // 初始加载当前tab的数据
    if (this.activeTab === 'student') {
      this.loadData()
      this.loadStats()
    } else if (this.activeTab === 'payment') {
      this.loadPaymentList()
      this.loadPaymentStats()
    } else if (this.activeTab === 'train-stats') {
      this.loadTrainStats()
    } else if (this.activeTab === 'exam') {
      this.loadExamRecords()
    }
  },
  watch: {
    activeTab(tab) {
      this.$router.replace({ query: { tab } })
      if (tab === 'student') {
        this.loadData()
        this.loadStats()
      } else if (tab === 'payment') {
        this.loadPaymentList()
        this.loadPaymentStats()
      } else if (tab === 'train-stats') {
        this.loadTrainStats()
      } else if (tab === 'exam') {
        this.loadExamRecords()
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push('/home/workbench')
    },
    handleTabChange(tab) {
      if (tab === 'student') {
        this.loadData()
        this.loadStats()
      } else if (tab === 'payment') {
        this.loadPaymentList()
        this.loadPaymentStats()
      } else if (tab === 'train-stats') {
        this.loadTrainStats()
      } else if (tab === 'exam') {
        this.loadExamRecords()
      }
    },
    async loadStats() {
      try {
        const result = await studentApi.getStudentStatistics()
        if (result) {
          this.statsOverview = {
            potential: result.potential || 0,
            active: result.active || 0,
            completed: result.completed || 0,
            unpaid: result.unpaid || 0
          }
        }
      } catch (e) {
        console.error('加载统计数据失败', e)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        const result = await studentApi.getStudentList(params)
        if (result) {
          this.tableData = result.list || []
          this.total = result.total || 0
        }
      } catch (e) {
        console.error('加载学员数据失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadPaymentList() {
      this.paymentLoading = true
      try {
        const params = {
          keyword: this.paymentSearchForm.keyword,
          auditStatus: this.paymentSearchForm.auditStatus,
          paymentStage: this.paymentSearchForm.paymentStage,
          page: this.paymentPagination.page,
          pageSize: this.paymentPagination.pageSize
        }
        const result = await studentApi.getPaymentList(params)
        if (result) {
          this.paymentData = result.list || []
          this.paymentTotal = result.total || 0
        }
      } catch (e) {
        console.error('加载缴费记录失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.paymentLoading = false
      }
    },
    async loadPaymentStats() {
      try {
        const result = await studentApi.getPaymentStatistics()
        if (result) {
          this.paymentStats = {
            pending: result.pending || 0,
            approvedAmount: result.approvedAmount || 0,
            totalAmount: result.totalAmount || 0,
            unpaidAmount: result.unpaidAmount || 0
          }
        }
      } catch (e) {
        console.error('加载缴费统计失败', e)
      }
    },
    async loadTrainStats() {
      this.trainStatsLoading = true
      try {
        const params = {
          keyword: this.trainStatsSearchForm.keyword,
          trainSubject: this.trainStatsSearchForm.trainSubject,
          page: this.trainStatsPagination.page,
          pageSize: this.trainStatsPagination.pageSize
        }
        if (this.trainStatsSearchForm.dateRange && this.trainStatsSearchForm.dateRange.length === 2) {
          params.startDate = this.trainStatsSearchForm.dateRange[0]
          params.endDate = this.trainStatsSearchForm.dateRange[1]
        }
        const result = await coachApi.getTrainRecordList(params)
        if (result) {
          this.trainStatsData = result.list || []
          this.trainStatsTotal = result.total || 0
          // 计算统计数据
          this.calculateTrainStats(result.list || [])
        }
      } catch (e) {
        console.error('加载培训统计失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.trainStatsLoading = false
      }
    },
    calculateTrainStats(data) {
      const studentIds = new Set()
      let k2Count = 0
      let k3Count = 0
      let totalHours = 0

      data.forEach(item => {
        studentIds.add(item.studentId)
        if (item.trainSubject === 'K2') k2Count++
        if (item.trainSubject === 'K3') k3Count++
        totalHours += parseFloat(item.trainHours || 0)
      })

      this.trainStatsOverview = {
        totalStudents: studentIds.size,
        k2Count,
        k3Count,
        totalHours: totalHours.toFixed(1)
      }
    },
    handleTrainStatsSizeChange(val) {
      this.trainStatsPagination.pageSize = val
      this.loadTrainStats()
    },
    handleTrainStatsPageChange(val) {
      this.trainStatsPagination.page = val
      this.loadTrainStats()
    },
    async loadExamRecords() {
      this.examLoading = true
      try {
        const params = {
          keyword: this.examSearchForm.keyword,
          examResult: this.examSearchForm.examResult,
          page: this.examPagination.page,
          pageSize: this.examPagination.pageSize
        }
        const result = await coachApi.getExamRecordList(params)
        if (result) {
          this.examData = result.list || []
          this.examTotal = result.total || 0
        }
      } catch (e) {
        console.error('加载考试成绩失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.examLoading = false
      }
    },
    handleExamSizeChange(val) {
      this.examPagination.pageSize = val
      this.loadExamRecords()
    },
    handleExamPageChange(val) {
      this.examPagination.page = val
      this.loadExamRecords()
    },
    getSubjectTagType(subject) {
      const map = { 'K1': 'primary', 'K2': 'success', 'K3': 'warning', 'K4': 'danger' }
      return map[subject] || 'info'
    },
    async loadCoachList() {
      try {
        const result = await studentApi.getCoachList()
        if (result) {
          const list = Array.isArray(result) ? result : (result.list || [])
          this.coachList = list.map(item => ({
            id: item.id || item.userId,
            name: item.nickName || item.userName || item.name
          }))
        }
      } catch (e) {
        console.error('加载教练列表失败', e)
      }
    },
    async loadDriverList() {
      try {
        const result = await studentApi.getDriverList()
        if (result) {
          const list = Array.isArray(result) ? result : (result.list || [])
          this.driverList = list.map(item => ({
            id: item.id || item.userId,
            name: item.nickName || item.userName || item.name
          }))
        }
      } catch (e) {
        console.error('加载司机列表失败', e)
      }
    },
    onIdCardFrontSuccess(data) {
      this.studentForm.idCardFrontUrl = data.originUrl
    },
    onIdCardBackSuccess(data) {
      this.studentForm.idCardBackUrl = data.originUrl
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
      this.loadStats()
    },
    handleReset() {
      this.searchForm = {
        keyword: '',
        studentStatus: '',
        paymentStatus: '',
        examType: '',
        coachUserId: '',
        driverUserId: ''
      }
      this.pagination.page = 1
      this.loadData()
      this.loadStats()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handlePaymentSizeChange(val) {
      this.paymentPagination.pageSize = val
      this.loadPaymentList()
    },
    handlePaymentPageChange(val) {
      this.paymentPagination.page = val
      this.loadPaymentList()
    },
    handleCreate() {
      this.dialogTitle = '新建学员'
      this.editId = null
      this.studentForm = {
        studentName: '',
        contactPhone: '',
        idCardNo: '',
        examType: '',
        hometown: '',
        currentLocation: '',
        departureCity: '',
        arrivalCity: '',
        expectedArrivalTime: '',
        trainInfo: '',
        totalFee: 0,
        studentStatus: 'POTENTIAL',
        remark: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑学员'
      this.editId = row.id
      this.studentForm = {
        studentName: row.studentName,
        contactPhone: row.contactPhone,
        idCardNo: row.idCardNo,
        idCardFrontUrl: row.idCardFrontUrl,
        idCardBackUrl: row.idCardBackUrl,
        examType: row.examType,
        hometown: row.hometown,
        currentLocation: row.currentLocation,
        departureCity: row.departureCity,
        arrivalCity: row.arrivalCity,
        expectedArrivalTime: row.expectedArrivalTime,
        trainInfo: row.trainInfo,
        currentSubject: row.currentSubject,
        totalFee: row.totalFee,
        paymentStage: row.paymentStage || 'NONE',
        studentStatus: row.studentStatus,
        remark: row.remark
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      try {
        this.submitLoading = true
        if (this.editId) {
          await studentApi.updateStudent(this.editId, this.studentForm)
          this.$message.success('更新成功')
        } else {
          await studentApi.createStudent(this.studentForm)
          this.$message.success('创建成功')
        }
        this.dialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      } finally {
        this.submitLoading = false
      }
    },
    handleAssign(row) {
      // 先初始化空值
      this.assignForm = {
        studentId: row.id,
        studentName: row.studentName,
        coachUserId: null,
        driverUserId: null
      }
      this.assignDialogVisible = true
      
      // 异步加载分配信息
      this.loadStudentAssignment(row.id)
    },
    async loadStudentAssignment(studentId) {
      try {
        const result = await studentApi.getStudentAssignment(studentId)
        if (result) {
          this.assignForm.coachUserId = result.coachUserId || null
          this.assignForm.driverUserId = result.driverUserId || null
        }
      } catch (e) {
        console.error('获取分配信息失败', e)
      }
    },
    async handleAssignSubmit() {
      try {
        const data = {
          studentId: this.assignForm.studentId
        }
        // 只有有值且不是 "undefined" 字符串才传递
        const coachId = this.assignForm.coachUserId
        const driverId = this.assignForm.driverUserId
        if (coachId && coachId !== 'undefined' && coachId !== 'null') {
          data.coachUserId = coachId
        }
        if (driverId && driverId !== 'undefined' && driverId !== 'null') {
          data.driverUserId = driverId
        }
        await studentApi.assignCoachAndDriver(data)
        this.$message.success('分配成功')
        this.assignDialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '分配失败')
      }
    },
    async handleView(row) {
      try {
        const result = await studentApi.getStudentDetail(row.id)
        this.viewData = result
        this.viewDialogVisible = true
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    async handleViewPayment(row) {
      this.paymentDetail = row
      this.paymentDetailVisible = true
    },
    handleEditPayment(row) {
      this.editingPaymentId = row.id
      this.paymentForm.studentId = row.studentId
      this.paymentForm.paymentStage = row.paymentType
      this.paymentForm.amount = row.paymentAmount
      this.paymentForm.paymentMethod = row.paymentMethod
      this.paymentForm.voucherUrl = row.voucherUrl
      this.paymentForm.remark = row.remark
      this.editPaymentVisible = true
    },
    async submitEditPayment() {
      try {
        await this.$refs.paymentFormRef.validate()
        this.paymentSubmitting = true
        await studentApi.updatePayment(this.editingPaymentId, {
          paymentStage: this.paymentForm.paymentStage,
          amount: this.paymentForm.amount,
          paymentMethod: this.paymentForm.paymentMethod,
          voucherUrl: this.paymentForm.voucherUrl,
          remark: this.paymentForm.remark
        })
        this.$message.success('修改成功')
        this.editPaymentVisible = false
        this.loadPaymentList()
        this.loadPaymentStats()
      } catch (e) {
        console.error('修改缴费失败', e)
        this.$message.error(e.message || '修改失败')
      } finally {
        this.paymentSubmitting = false
      }
    },
    async handleApprovePayment(row, status) {
      try {
        await this.$confirm('确定通过该缴费记录？', '提示', {
          type: 'success'
        })
        await studentApi.auditPayment(row.id, status, '')
        this.$message.success('审核通过')
        this.loadPaymentList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleRejectPayment(row) {
      try {
        const remark = await this.$prompt('请输入拒绝原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '请输入拒绝原因'
        })
        await studentApi.auditPayment(row.id, 'REJECTED', remark.value)
        this.$message.success('已拒绝')
        this.loadPaymentList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleLockPayment(row) {
      try {
        await this.$confirm('确定锁定该账单？锁定后将无法修改。', '提示', {
          type: 'warning'
        })
        await studentApi.lockBill(row.id)
        this.$message.success('账单已锁定')
        this.loadPaymentList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    getStatusTagType(status) {
      const map = {
        'POTENTIAL': 'info',
        'ACTIVE': 'success',
        'COMPLETED': '',
        'DROPPED': 'danger',
        'REFUND_APPLY': 'warning',
        'ABANDON': 'danger'
      }
      return map[status] || ''
    },
    getStatusName(status) {
      const map = {
        'POTENTIAL': '潜在学员',
        'ACTIVE': '在学',
        'COMPLETED': '已毕业',
        'DROPPED': '已退学',
        'REFUND_APPLY': '申请退费',
        'ABANDON': '放弃学习'
      }
      return map[status] || status
    },
    getPaymentTagType(status) {
      const map = {
        'UNPAID': 'danger',
        'PARTIAL': 'warning',
        'PAID': 'success'
      }
      return map[status] || ''
    },
    getPaymentName(status) {
      const map = {
        'UNPAID': '未缴费',
        'PARTIAL': '部分缴费',
        'PAID': '已缴清'
      }
      return map[status] || status
    },
    getPaymentStatusTagType(status) {
      const map = {
        'PENDING': 'warning',
        'APPROVED': 'success',
        'REJECTED': 'danger',
        'LOCKED': 'info'
      }
      return map[status] || ''
    },
    getPaymentStageName(stage) {
      const map = {
        'NONE': '未付款',
        'DEPOSIT': '定金',
        'INSTALLMENT': '分期',
        'FULL': '全款'
      }
      return map[stage] || stage || '-'
    },
    getSubjectName(subject) {
      const map = {
        'K1': '科一(理论)',
        'K2': '科二(场地)',
        'K3': '科三(道路)',
        'K4': '科四(安全)'
      }
      return map[subject] || subject || '-'
    },
    // 新建缴费相关方法
    handleAddPayment() {
      this.addPaymentVisible = true
      this.paymentForm = {
        studentId: null,
        paymentStage: '',
        amount: 0,
        paymentMethod: '',
        paymentDate: new Date().toISOString().slice(0, 10),
        voucherUrl: '',
        remark: ''
      }
      this.studentOptions = []
      this.selectedStudentInfo = {}
    },
    resetPaymentForm() {
      this.$refs.paymentFormRef && this.$refs.paymentFormRef.resetFields()
      this.paymentForm = {
        studentId: null,
        paymentStage: '',
        amount: 0,
        paymentMethod: '',
        paymentDate: '',
        voucherUrl: '',
        remark: ''
      }
      this.editingPaymentId = null
      this.studentOptions = []
      this.selectedStudentInfo = {}
    },
    resetTrainRecordForm() {
      this.$refs.trainRecordFormRef && this.$refs.trainRecordFormRef.resetFields()
      this.trainRecordForm = {
        id: '',
        studentName: '',
        trainSubject: '',
        trainDate: '',
        trainHours: 0,
        trainContent: '',
        progressRecord: ''
      }
    },
    resetExamRecordForm() {
      this.$refs.examRecordFormRef && this.$refs.examRecordFormRef.resetFields()
      this.examRecordForm = {
        id: '',
        studentName: '',
        examSubject: '',
        examDate: '',
        examTimes: 1,
        examResult: 'PASS',
        score: 0,
        failReason: '',
        remark: ''
      }
    },
    handleEditExam(row) {
      this.examRecordForm = {
        id: row.id,
        studentName: row.studentName,
        examSubject: row.examSubject,
        examDate: row.examDate,
        examTimes: row.examTimes || 1,
        examResult: row.examResult || 'PASS',
        score: row.score || 0,
        failReason: row.failReason || '',
        remark: row.remark || ''
      }
      this.editExamRecordVisible = true
    },
    async submitExamRecord() {
      try {
        await this.$refs.examRecordFormRef.validate()
        this.examRecordLoading = true
        await coachApi.updateExamRecord(this.examRecordForm)
        this.$message.success('修改成功')
        this.editExamRecordVisible = false
        this.loadExamRecords()
      } catch (e) {
        if (e !== false) {
          this.$message.error(e.message || '操作失败')
        }
      } finally {
        this.examRecordLoading = false
      }
    },
    async submitTrainRecord() {
      try {
        await this.$refs.trainRecordFormRef.validate()
        this.trainRecordLoading = true
        await studentApi.updateTrainRecord(this.trainRecordForm)
        this.$message.success('修改成功')
        this.editTrainRecordVisible = false
        this.loadTrainStats()
      } catch (e) {
        if (e !== false) {
          this.$message.error(e.message || '操作失败')
        }
      } finally {
        this.trainRecordLoading = false
      }
    },
    async searchStudents(query) {
      if (!query) {
        this.studentOptions = []
        return
      }
      this.studentSearchLoading = true
      try {
        const result = await studentApi.getStudentList({ keyword: query, page: 1, pageSize: 20 })
        if (result && result.list) {
          this.studentOptions = result.list
        }
      } catch (e) {
        console.error('搜索学员失败', e)
      } finally {
        this.studentSearchLoading = false
      }
    },
    async onStudentChange(studentId) {
      if (!studentId) {
        this.selectedStudentInfo = {}
        return
      }
      const student = this.studentOptions.find(s => s.id === studentId)
      if (student) {
        this.selectedStudentInfo = student
      } else {
        try {
          const result = await studentApi.getStudent(studentId)
          if (result) {
            this.selectedStudentInfo = result
          }
        } catch (e) {
          console.error('获取学员信息失败', e)
        }
      }
    },
    onVoucherSuccess(data) {
      this.paymentForm.voucherUrl = data.originUrl
      this.$message.success('上传成功')
    },
    async submitPayment() {
      this.$refs.paymentFormRef.validate(async (valid) => {
        if (!valid) return
        this.paymentSubmitting = true
        try {
          await studentApi.uploadPaymentVoucher({
            studentId: this.paymentForm.studentId,
            paymentStage: this.paymentForm.paymentStage,
            amount: this.paymentForm.amount,
            paymentMethod: this.paymentForm.paymentMethod,
            paymentDate: this.paymentForm.paymentDate,
            voucherUrl: this.paymentForm.voucherUrl,
            remark: this.paymentForm.remark
          })
          this.$message.success('提交成功，请等待财务审核')
          this.addPaymentVisible = false
          this.loadPaymentList()
          this.loadPaymentStats()
        } catch (e) {
          console.error('提交缴费失败', e)
          this.$message.error(e.message || '提交失败')
        } finally {
          this.paymentSubmitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.student-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.main-tabs {
  margin: 15px 20px;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.stats-cards {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.voucher-preview {
  display: flex;
  align-items: center;
  gap: 10px;
}

.voucher-uploader {
  display: inline-block;

  ::v-deep .el-upload {
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.2s;
    width: 200px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      border-color: #409eff;
    }
  }
}

.voucher-preview-box {
  position: relative;
  width: 100%;
  height: 100px;

  .upload-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    font-size: 12px;
    padding: 4px 0;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover .upload-tip {
    opacity: 1;
  }
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #ebeef5;
}

.stat-card .stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 16px;
}

.stat-card .stat-icon.potential { background: linear-gradient(135deg, #909399 0%, #b1b3b8 100%); }
.stat-card .stat-icon.active { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card .stat-icon.completed { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.stat-card .stat-icon.unpaid { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }
.stat-card .stat-icon.pending { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.stat-card .stat-icon.approved { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card .stat-icon.total { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.stat-card .stat-icon.k2 { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card .stat-icon.k3 { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.stat-card .stat-icon.hours { background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%); }

.stat-card .stat-info .stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.stat-card .stat-info .stat-label {
  font-size: 14px;
  color: #909399;
}

.section-title {
  font-weight: bold;
  margin-bottom: 16px;
  color: #303133;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
}

.section-title i {
  margin-right: 8px;
  color: #409eff;
}

.el-table {
  background: #fff;
  border-radius: 4px;
}

.table-card {
  border-radius: 8px;
  background: #fff;
  padding: 15px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-count {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.unpaid {
  color: #f56c6c;
}

.no-assign {
  color: #909399;
  font-style: italic;
}

.money {
  color: #67c23a;
  font-weight: bold;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 15px;
}

.total-text {
  font-size: 14px;
  color: #606266;
}

.id-card-preview {
  margin-top: 8px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.id-card-images {
  display: flex;
  gap: 20px;
}

.id-card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.id-card-label {
  font-size: 12px;
  color: #909399;
}

.id-card-uploader {
  display: inline-block;

  ::v-deep .el-upload {
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.2s;
    width: 200px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      border-color: #409eff;
    }
  }
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
  width: 100%;

  i {
    font-size: 28px;
    margin-bottom: 4px;
  }
}

.id-card-preview {
  position: relative;
  width: 100%;
  height: 100px;

  .upload-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    font-size: 12px;
    padding: 4px 0;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover .upload-tip {
    opacity: 1;
  }
}
</style>
